import type { DocumentFromResponse } from 'shared/features/documents/documents.types';

export const getAuthors = ({ document }: { document: DocumentFromResponse }) => {
  if (document.authors) {
    return document.authors
      .map(a => a.name)
      .sort()
      .join(', ');
  }

  return '';
};
